import create from 'zustand';
import { AdaptFiltersState, FiltersVisibility } from './interfaces/AdaptFiltersState';

export const defaultFiltersVisibility: FiltersVisibility = {
  search: true,
  project: true,
  targetLanguage: false,
  status: true,
  createdBy: true,
  qualityExpert: true,
  projectManager: true,
  queryResponsible: true,
  assignee: true,
  answerer: false,
  translationType: false,
  xtmProjectName: true,
  filename: false,
  submitterGroupName: true,
  loio: false,
  repository: false,
  collection: false,
  stringId: false,
  distributed: true,
  queryTrackerId: false,
  createdAt: false,
  implementationStatus: false,
  implementationLanguage: false,
  account: false,
  applicationComponent: false,
  substitutePm: false,
  issueType: false,
  sourceContact: false,
  objectName: false,
  objectType: false,
  translationArea: false
};

export const useAdaptFiltersStore = create<AdaptFiltersState>((set) => ({
  filtersVisibility: { ...defaultFiltersVisibility },
  setFiltersVisibility: (value: FiltersVisibility) => set(() => ({ filtersVisibility: value }))
}));
